export const globalStore = {

}